// Utility functions for formatting data

/**
 * Format a US phone number with dashes (XXX-XXX-XXXX)
 * @param {string} phoneNumber - The phone number to format
 * @returns {string} - Formatted phone number or original if invalid
 */
export function formatPhoneNumber(phoneNumber) {
  if (!phoneNumber) {
    return '';
  }
  
  // Remove all non-digits
  const cleaned = phoneNumber.toString().replace(/\D/g, '');
  
  // Check if it's a valid US phone number (10 digits)
  if (cleaned.length === 10) {
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
  }
  
  // If it's 11 digits and starts with 1, remove the 1 and format
  if (cleaned.length === 11 && cleaned.charAt(0) === '1') {
    const withoutCountryCode = cleaned.slice(1);
    return `${withoutCountryCode.slice(0, 3)}-${withoutCountryCode.slice(3, 6)}-${withoutCountryCode.slice(6, 10)}`;
  }
  
  // Return original if it doesn't match expected patterns
  return phoneNumber;
}
